import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ClinicalReportSection from "./ClinicalReportSection";
import { invoiceRecordConfig } from "./abhaClinicalConfigs";
import { getAllDataByPatientId } from "../../../../store/slices/invoiceSlice";

const InvoiceRecordSection = ({ patientId, patientData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { patientDetails, loading, patientDetailsForPatientId } = useSelector(
    (state) => state.invoice,
  );

  const clinicId = clinicInfo?.[0]?.clinicId || null;

  useEffect(() => {
    if (!token || !patientId || !clinicId) return;
    const toDate = new Date().toISOString().split("T")[0];
    dispatch(
      getAllDataByPatientId({
        patientId,
        clinicId,
        fromDate: "2000-01-01",
        toDate,
        token,
      }),
    );
  }, [dispatch, token, patientId, clinicId]);

  const externalRows = useMemo(
    () => {
      if (String(patientDetailsForPatientId || "") !== String(patientId || "")) {
        return [];
      }

      const invoices = Array.isArray(patientDetails?.invoices)
        ? patientDetails.invoices
        : [];

      return invoices
        .filter((inv) => {
          const invoicePatientId = String(
            inv?.appointmentDetails?.patientId?._id ||
              inv?.appointmentDetails?.patientId ||
              "",
          );
          return invoicePatientId === String(patientId || "");
        })
        .map((inv) => ({
          _id: `ext-${inv?._id}`,
          invoiceId: inv?.invoiceId || "-",
          consultationDate:
            inv?.appointmentDetails?.appDate || inv?.createdAt || "",
          appointmentId: inv?.appointmentDetails?.appointmentId || "-",
          invoiceAmount: inv?.totalAmount || 0,
          sourceStatusText: "Not Linked",
          __sourceInvoiceDbId: inv?._id,
        }));
    },
    [patientDetailsForPatientId, patientDetails?.invoices, patientId],
  );

  const handleExternalView = (item) => {
    const invoiceDbId = item?.__sourceInvoiceDbId;
    if (!invoiceDbId) return;
    sessionStorage.setItem("invoiceId", String(invoiceDbId));
    navigate("/view_invoice");
  };

  return (
    <ClinicalReportSection
      patientId={patientId}
      patientData={patientData}
      config={invoiceRecordConfig}
      externalRows={externalRows}
      externalLoading={loading}
      onExternalView={handleExternalView}
    />
  );
};

export default InvoiceRecordSection;
